import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import { useNavigate } from "react-router-dom";
import backend from "../../../../../api";
import { useSelector } from "react-redux";

export default function BookingSetup({ initial, saveProfile, onBack }) {
  const navigateTo = useNavigate();
  const [form, setForm] = useState({ ratePerSession: "", calendarLink: "" });
  const [saving, setSaving] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;

  // ⬇️ keep in sync with prop
  useEffect(() => {
    if (!initial) return;
    setForm({
      ratePerSession: initial.ratePerSession ?? "",
      calendarLink: initial.calendarLink ?? "",
    });
  }, [initial]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await saveProfile({ bookingSetup: form });
    setSaving(false);
    navigateTo("/");
  };

  async function handleConnectClick() {
    const response = await backend.get(`/pay/connect/authorize?userId=${userId}`);
    if (response?.data.url) window.location.href = response.data.url;
  }

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <div className={Classes.infoConMiddle}>
          {/* <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Set Your Rate (Per Session)</h5>
              <input
                type="number"
                name="ratePerSession"
                className={Classes.inputField}
                placeholder="$100"
                value={form.ratePerSession}
                onChange={(e) => setForm((p) => ({ ...p, ratePerSession: e.target.value }))}
                required
              />
            </div>
          </div> */}

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Connect Your Stripe</h5>
              <div className={Classes.flexBetween}>
                <div className={Classes.flexAlign102}>
                  <img src="/assets/icons/stripe.png" alt="stripe" className={Classes.stripeImg} />
                  <div>
                    <h5>Stripe</h5>
                    <h5 className={Classes.label}>Collect payments for your meetings</h5>
                  </div>
                </div>
                <button type="button" className={Classes.connectBtn} onClick={handleConnectClick}>
                  <h5>Connect</h5>
                </button>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" className={Classes.saveBtn}><h5>Finish</h5></button>
      </form>
    </>
  );
}
